import { Injectable } from '@angular/core';
import { MuiModalService } from '@move/ui';
import { MmuPlanDetails } from '../../models/mmu-plan-details';
import { MmuUserService } from '../../user-service/mmu-user.service';
import { MmuPlanPermissionDialogComponent } from '../plan-permission-dialog/mmu-plan-permission-dialog.component';


export type MmuPlanDetailsReduced = Omit<MmuPlanDetails, 'id'>;

//const name: keyof MmuPlanDetailsReduced = 'approvalSignature';
//const foo: MmuPlanDetails['approvalSignature'] = 30;

type KeysMatching<T, V> = { [K in keyof T]-?: T[K] extends V ? K : never }[keyof T];
type BooleanKeys<T> = KeysMatching<T, boolean | undefined>;
type NumericKeys<T> = KeysMatching<T, number | undefined>;


export type MmuPlanPermissionNumericKey = NumericKeys<MmuPlanDetails>;
export type MmuPlanPermissionBooleanKey = BooleanKeys<MmuPlanDetails>;
export type MmuPlanPermissionKey = MmuPlanPermissionBooleanKey | MmuPlanPermissionNumericKey;

@Injectable({
  providedIn: 'root'
})
export class MmuPlanPermissionService {
  currentPlan: MmuPlanDetails | null = null;

  constructor(private modalService: MuiModalService, private userService: MmuUserService) {
    this.userService.currentPlan$.subscribe((plan: MmuPlanDetails) => {
      this.currentPlan = plan || {} as MmuPlanDetails;
    });
  }

  /**
   * @param name - name of the permit
   * @param compareWith - value to compare with (only for numeric permits)
   */
  getPermit<N extends NumericKeys<MmuPlanDetails> = NumericKeys<MmuPlanDetails>>(name: N, compareWith: number): boolean;
  getPermit<N extends BooleanKeys<MmuPlanDetails> = BooleanKeys<MmuPlanDetails>>(name: N): boolean;
  getPermit<N extends MmuPlanPermissionKey = MmuPlanPermissionKey, C extends MmuPlanDetails[N] = MmuPlanDetails[N]>(
    name: N,
    compareWith?: C
  ): boolean {
    if (!this.currentPlan || !Object.prototype.hasOwnProperty.call(this.currentPlan, name)) {
      return false;
    }

    const value = this.currentPlan[name];

    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number' && typeof compareWith === 'number') {
      return value >= compareWith;
    }

    return false;
  }

  /**
   * @param hideCloseButton - set true to hide close button on top
   */
  openPaywall(hideCloseButton = false): void {
    this.modalService.open(MmuPlanPermissionDialogComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: hideCloseButton ? 'hide-close' : ''
    });
  }
}
